module.exports = __webpack_public_path__ + "public/Icons/3mobileappsettings.svg?19d16288";